import React, { Fragment } from 'react';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

export default [
  {
    header: (
      <>
        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
        <TranslatedCopy id='global.size' />{' '}
      </>
    ),
    id: 'code',
    cell: data => {
      return <span>{data.sizeDisplay || data.code}</span> || null;
    }
  },
  {
    header: (data, { totalRequestedQty }) => (
      <>
        <TranslatedCopy id='global.requested' />
        <span className='d-sm-h d-md-b'>
          {': '}
          {totalRequestedQty}
        </span>
      </>
    ),
    id: 'totalRequestedQty'
  },
  {
    header: (data, { totalConfirmedQty }) => (
      <>
        <TranslatedCopy id='global.confirmed' />
        <span className='d-sm-h d-md-b'>
          {': '}
          {totalConfirmedQty}
        </span>
      </>
    ),
    id: 'totalConfirmedQty'
  },
  {
    header: (data, { totalShippedQty }) => (
      <>
        <TranslatedCopy id='global.shipped' />
        <span className='d-sm-h d-md-b'>
          {': '}
          {totalShippedQty}
        </span>
      </>
    ),
    id: 'totalShippedQty'
  },
  {
    header: (data, { totalCancelledQty }) => (
      <>
        <TranslatedCopy id='global.cancelled' />
        <span className='d-sm-h d-md-b'>
          {': '}
          {totalCancelledQty}
        </span>
      </>
    ),
    id: 'totalCancelledQty',
    cell: data => {
      return data.totalCancelledQty > 0 ? (
        <div
          style={{
            backgroundColor: '#f200001a',
            width: '100%',
            height: '100%',
            textAlign: 'center',
            paddingTop: '10px'
          }}
        >
          <span className='text-color-error'>{data.totalCancelledQty}</span>
        </div>
      ) : (
        <span>{data.totalCancelledQty}</span>
      );
    }
  }
];
